import React from "react";
import starWhite from "../../assests/starWhite.png";
import styles from "./DynamicCarousel.module.css";
function HowToParticiapteInCarousel({
  howToParticipate,
  hexCode,
  handleClick,
  scrollRef,
}) {
  var coverStyle = {
    background: `url(${howToParticipate?.thumbnailUrl}) no-repeat center center`,
  };
  var linkStyle = { color: hexCode };
  return (
    <div
      className=" h-[194px] w-[320px] shrink-0 flex-grow flex items-end cursor-pointer"
      style={coverStyle}
      onClick={handleClick}
      ref={scrollRef}
    >
      <div className={styles.howToParticipateButtonBar}>
        <img src={starWhite} className="w-[13px] h-[13px]" />
        <p className="text-small text-[#FFE100]">
          {" "}
          Watch this video to learn more
        </p>
      </div>
    </div>
  );
}

export default HowToParticiapteInCarousel;
